
import { doc, getDoc, setDoc } from "firebase/firestore"
import { db } from "../../Firebase"
import moment from 'moment'

export const addUserToFb = async(userData) => {
    console.log('sekvbskjdvbnskjdvb')
    try {
        await setDoc(doc(db, "users", `${userData.userId}`), {
          userId: userData.userId,
          userName: userData.firstName + " " + (userData?.lastName || ""),
          userType: userData?.profession_type_desc || "",
          age:
            userData?.age ||
            (userData?.dob && moment().diff(moment(userData.dob), "years")) ||
            "N/A",
          gender: userData?.gender
            ? Number(userData.gender) === 100030002
              ? "Male"
              : Number(userData.gender) === 100030001
              ? "Female"
              : "Undefined"
            : "N/A",
          mobileNo: userData?.mobileNo || userData?.mobile_no || "",
          emailId: userData?.email || userData?.email || "",
        })

        const docRef = doc(db, "userChats", `${userData.userId}`)

        // Check if the document exists
        const docSnap = await getDoc(docRef)

        // If the document doesn't exist, set the document
        if (!docSnap.exists()) {
          await setDoc(docRef, {})
        }
      } catch (err) {
        console.log(err, "lkfjdfjlf")
      }
}

export default addUserToFb;